<template>
  <div v-if="mountViews">
    <top-menu
      app
      @toggle-drawer="$refs.drawer.drawer = !$refs.drawer.drawer"
      :logoutTimer="false"
      :providers="usersProviders"
      :provider-id="providerId"
      :hostingRepresentative="userRepresentative || {}"
      :representativeId="representativeId"
    />
    <!-- <left-sidebar ref="drawer" /> -->
    <filtering></filtering>
    <v-main>
      <v-row
        v-if="firstTime && $store.getters.roles === 'provider' && $route.name !== 'AddProvider'"
        justify="center"
        align="center"
      >
        <v-card
          class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
          elevation="3"
          style="border-radius: 24px; background-color: rgba(237, 224, 255, 1) !important;"
        >
          <div class="text-center">
            <router-link :to="{ name: 'AddProvider' }" class="primary200--text text-bold text-h6">
              {{ $t('add-your-provider') }}
              <v-icon x-large>mdi-plus-circle</v-icon>
            </router-link>
          </div>
        </v-card>
      </v-row>
      <v-row
        v-if="
          firstTime &&
            $store.getters.roles === 'institution-representative' &&
            $route.name !== 'AddHostingInstitution' &&
            !isDisabled
        "
        justify="center"
        align="center"
      >
        <v-card
          class="mt-6 pa-3 pa-sm-6 pa-lg-6 pa-md-6 pa-xl-6"
          elevation="3"
          style="border-radius: 24px; background-color: rgba(237, 224, 255, 1) !important;"
        >
          <div class="text-center">
            <router-link
              :to="{ name: 'AddHostingInstitution' }"
              class="primary200--text text-bold text-h6"
            >
              {{ $t('add-your-hosting-institution') }}
              <v-icon x-large>mdi-plus-circle</v-icon>
            </router-link>
          </div>
        </v-card>
      </v-row>
      <router-view :key="$route.fullPath"></router-view>
    </v-main>
    <footer-landing-new></footer-landing-new>
  </div>
</template>

<script>
import TopMenu from '@/components/TopMenu';
// import LeftSidebar from '@/components/LeftSidebar';
import base from '@/services/base-service.js';
import Filtering from '@/components/shared/Filtering';
import FooterLandingNew from '../components/shared/landing-page/FooterLandingNew.vue';

export default {
  name: 'DashboardLayout',
  mixins: [base],
  components: {
    Filtering,
    TopMenu,
    FooterLandingNew,
  },
  data() {
    return {
      providerId: null,
      usersProviders: [],
      mountViews: false,
      firstTime: false,
      userRepresentative: {},
      representativeId: null,
    };
  },
  created() {
    if (this.$store.getters.roles === 'provider') {
      this.axios
        .get('/api/v1/providers/my')
        .then(res => {
          this.usersProviders = res.data.content;
          if (this.usersProviders != null && this.usersProviders.length != 0) {
            if (sessionStorage.getItem('providerId')) {
              console.log('Session Storage: ' + sessionStorage.getItem('providerId'));
              this.providerId = Number(sessionStorage.getItem('providerId'));
            } else if (localStorage.getItem('providerId')) {
              console.log('Local Storage: ' + localStorage.getItem('providerId'));
              this.providerId = Number(localStorage.getItem('providerId'));
              sessionStorage.setItem('providerId', this.providerId);
            } else {
              console.log('Empty storage: ' + localStorage.getItem('providerId'));
              this.providerId = res.data.content[0].id;
              localStorage.setItem('providerId', this.providerId);
              sessionStorage.setItem('providerId', this.providerId);
            }
            if (this.usersProviders.filter(x => x.id == this.providerId).length == 0) {
              this.providerId = res.data.content[0].id;
              localStorage.setItem('providerId', this.providerId);
              sessionStorage.setItem('providerId', this.providerId);
            }
            let provider = this.usersProviders.find(x => x.id == this.providerId);
            this.firstTime = provider.draft;
            sessionStorage.setItem('firstTime', this.firstTime);
          } else {
            // FIRST TIME
            sessionStorage.setItem('firstTime', true);
            sessionStorage.removeItem('providerId');
            this.firstTime = true;
          }
          this.$nextTick(() => {
            this.mountViews = true;
          });
        })
        .catch(error => {
          console.log({ error });
        });
    } else if (this.$store.getters.roles === 'institution-representative') {
      this.axios.get('/api/v1/hosting-institutions/my').then(res => {
        this.userRepresentative = res.data;

        if (Object.keys(this.userRepresentative).length !== 0) {
          if (sessionStorage.getItem('representativeId')) {
            console.log('Session Storage: ' + sessionStorage.getItem('representativeId'));
            this.representativeId = Number(sessionStorage.getItem('representativeId'));
          } else if (localStorage.getItem('representativeId')) {
            console.log('Local Storage: ' + localStorage.getItem('representativeId'));
            this.representativeId = Number(localStorage.getItem('representativeId'));
            sessionStorage.setItem('representativeId', this.representativeId);
          } else {
            console.log('Empty storage: ' + localStorage.getItem('representativeId'));
            this.representativeId = res.data.id;
            localStorage.setItem('representativeId', this.representativeId);
            sessionStorage.setItem('representativeId', this.representativeId);
          }
          if (this.userRepresentative.id) {
            this.representativeId = res.data.id;
            localStorage.setItem('representativeId', this.representativeId);
            sessionStorage.setItem('representativeId', this.representativeId);
          }
          sessionStorage.setItem('firstTime', this.firstTime);
        } else {
          // FIRST TIME
          sessionStorage.setItem('firstTime', true);
          sessionStorage.removeItem('representativeId');
          this.firstTime = true;
        }

        this.$nextTick(() => {
          this.mountViews = true;
        });
      });
    } else {
      this.mountViews = true;
    }
  },
  computed: {
    isDisabled() {
      return sessionStorage.getItem('disabled') === 'true';
    },
  },
};
</script>
